import axiosInstance from '../config/axios';

/**
 * Check if the user has set up a PIN
 */
export const getPinStatusApi = () =>
  axiosInstance.get('/pin/status').then((res) => res.data);

/**
 * Send a verification code to the user's email to set/reset the PIN
 */
export const sendPinCodeApi = () =>
  axiosInstance.get('/pin/send-code').then((res) => res.data);

/**
 * Verify the verification code to generate/send the PIN to the email
 * @param {Object} data - { code }
 */
export const verifyPinCodeApi = (data) =>
  axiosInstance.post('/pin/verify-code', data).then((res) => res.data);

/**
 * Create a custom PIN
 * @param {Object} data - { pin }
 */
export const createPinApi = (data) =>
  axiosInstance.post('/pin/create', data).then((res) => res.data);

/**
 * Match/verify the entered PIN
 * @param {Object} data - { pin }
 */
export const matchPinApi = (data) =>
  axiosInstance.post('/pin/match', data).then((res) => res.data);
